{
  "iron_ore": { "name": "Mineral de hierro", "color": "#9aa7b6" },
  "iron_plate": { "name": "Placas de hierro", "color": "#9aa7b6" },
  "gear": { "name": "Engranajes", "color": "#8d97a5" }
}
